module.exports = __webpack_public_path__ + "img/maya_logo.1bf5cf03.png";